import * as React from 'react'
import styled from 'styled-components'
import {Link} from 'react-router-dom'
import {Content} from '../../atoms/Content'
import {Hcp31View} from '../../organisms/HCP3-1/HCP3_1_View'
import {IntakeProgressBar} from '../../molecules/IntakeProgressBar'
import {Layout} from '../../atoms/Layout'
import {Nav} from '../../atoms/Nav'
import {OccupationNavBar} from '../../molecules/OccupationNavBar'
import {ProfileDropdown} from '../../organisms/ProfileDropdown'
import {media} from '../../utils/media'
import {withRouter} from 'react-router'
import MenuStore from '../../stores/MenuStore'
import MobileMenu from '../../atoms/MobileMenu'

export const HCP3_1 = withRouter((props) => {
  const menuStore = MenuStore.create({})

  return (
    <Layout>
      <Nav.BarTips>
        <Nav.HomeButtonTips showHamburger={false}/>
        <ProfileDropdown color={null}/>
      </Nav.BarTips>
      <MobileMenu store={menuStore}/>
      <OccupationNavBar className="no-print occupationNavBar">
        <Link to="/HCP3-patientInfo" style={{textDecoration: 'none'}}><H2 active={true}>Patient Info</H2></Link>
        <Link to="/contents/HCP3-1" style={{textDecoration: 'none'}}><H2 active={false}>Pre-op Anxiety</H2></Link>
        <Link to="/contents/HCP3-2" style={{textDecoration: 'none'}}><H2 active={false}>Parent Education</H2></Link>
        <Link to="/contents/HCP3-3a" style={{textDecoration: 'none'}}><H2 active={false}>Parent Training</H2></Link>
        <Link to="/contents/HCP3-4" style={{textDecoration: 'none'}}><H2 active={false}>Model Behavior</H2></Link>
        <Link to="/contents/HCP3-5" style={{textDecoration: 'none'}}><H2 active={false}>Summary</H2></Link>
      </OccupationNavBar>
      <Content style={{marginTop: 100}}>
        <Hcp31View/>
        <IntakeProgressBar
          count={7}
          currentIndex={0}
          goToNext={() => {
            props.history.push('/contents/HCP3-1')
          }}
          goToPrev={null}/>
      </Content>
    </Layout>
  )
})

const H2 = styled.div`
  font-family: Nunito;
  font-size: 22px;
  font-weight: 900;
  color: ${({active}) => active ? '#FC9426' : '#AEBFCC'};
  margin: 24px 25px;

  ${media.tablet`
    font-size: 22px;
  `}
`



// WEBPACK FOOTER //
// ./src/pages/HCP3-patientInfo/index.js